














import { Component, Vue } from "vue-property-decorator";

@Component({ name: "TransitionExpand" })
export default class TransitionExpand extends Vue {
  public beforeEnter(el: HTMLElement): void {
    el.style.height = "0";
    el.style.overflow = "hidden";
  }

  public enter(el: HTMLElement): void {
    el.style.height = `${el.scrollHeight}px`;
  }

  public afterEnter(el: HTMLElement): void {
    el.style.height = "auto";
    el.style.overflow = "";
  }

  public beforeLeave(el: HTMLElement): void {
    el.style.height = `${el.scrollHeight}px`;
    el.style.overflow = "hidden";
  }

  public leave(el: HTMLElement): void {
    void el.offsetHeight; // force reflow before animating to 0
    el.style.height = "0";
  }

  public afterLeave(el: HTMLElement): void {
    el.style.height = "";
    el.style.overflow = "";
  }
}
